export enum AssignmentFilterType {
  Assigned = 'assigned',
  PendingAssignment = 'pending-assignment',
  PendingUnassignment = 'pending-unassignment'
}